import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { RotatingLines } from "react-loader-spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";

function Payment() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [payBtn, setPayBtn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [customer, setCustomer] = useState({});
  const [staff, setStaff] = useState([]);
  const [stb, setStb] = useState(null);

  const [payAmount, setPayAmount] = useState(0);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [isVisible, setIsVisible] = useState(false);
const [paymentMode, setPaymentMode] = useState("Cash");
const [chequeNo, setChequeNo] = useState("");
const [remarks, setRemarks] = useState("");
const [paymentFor, setPaymentFor] = useState("");
  // 🔹 Get cookie
  const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) return value;
    }
    return null;
  };

  const user = getCookie("user");
  const isStaff = getCookie('isStaff') === "true";

const secretId = getCookie('secretId');
console.log("User:", user, "isStaff:", isStaff, "secretId:", secretId);

const fetchUserData = useCallback(async () => {
  try {
    const payload = { user, id, secretId, isStaff }; // ✅ add isStaff

    const response = await axios.post(
      "https://node.cabletvpay.in/paymentCustomer",
      payload
    );

    if (response.status === 200) {
      const cust = response.data.res[0];

      setCustomer(cust);
      setStaff(response.data.staff);
      setStb(cust.serial_num);

      const balanceAmt = Number(cust.balance_amt) || 0;
      const pendAmt = Number(cust.pend_amt) || 0;

      const finalAmount =
        cust.status === "unpaid" ? balanceAmt + pendAmt : balanceAmt;

      setPayAmount(finalAmount);
    }
  } catch (err) {
    setError(err.response?.data?.message || "Error fetching data");
  } finally {
    setLoading(false);
  }
}, [id, user, isStaff, secretId]);

  // 🔹 Load on mount
  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }
    fetchUserData();
  }, [fetchUserData, user, navigate]);

  // 🔹 Save payment
  const handleSave = async () => {
    if (!payAmount || !selectedStaff) {
      toast.error("Please enter an amount and select a staff member.");
      return;
    }

    try {
      setPayBtn(true);

      const response = await axios.post(
        "https://node.cabletvpay.in/updatePayment",
        { id, payAmount, selectedStaff, user, stb, paymentMode,
    chequeNo,
    remarks,
    paymentFor}
      );

      if (response.status === 200) {
        toast.success("Payment updated successfully!");

        setTimeout(() => {
          navigate("/allCustomer/all", {
            state: { customerId: response.data.id },
          });
        }, 1200);
      }
    } catch {
      toast.error("Error updating payment!");
      setPayBtn(false);
    }
  };

  // 🔹 Loading UI
  if (loading) {
    return (
      <div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
          <RotatingLines visible height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="3" />
        </div>
      </div>
    );
  }

  // 🔹 Error UI
  if (error) {
    return (
      <div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
          <img src="/asset/img/errorPage.jpg" alt="Error" style={{ height: "20rem" }} />
        </div>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <div className="content-header pt-1">
        <div className="my-3">
          <div className="fs-4 valuesDec h4">Payment Details</div>
          <ToastContainer theme="dark" />
        </div>

        <div className="mx-lg-5 px-lg-5">
          <div className="d-flex justify-content-center">
            <div className="card card-widget widget-user elevation-5 w-100">

              {/* Header */}
              <div className="widget-user-header bg-info">
                <h3 className="widget-user-username text-bold">{customer.acc_num}</h3>
                <h5 className="widget-user-desc text-bold h4">Plan Amount ₹ {customer.pay_amt}</h5>
              </div>

              {/* Avatar */}
              <div className="widget-user-image">
                <img className="img-circle elevation-5" src="/asset/img/user.png" alt="User Avatar" height="100" width="100" />
              </div>

              {/* Body */}
              <div className="card-footer">
                <div className="row">

                  {[
                    ["Name", customer.name],
                    ["Code", customer.acc_num],
                    ["STB number", customer.serial_num],
                    ["Network", customer.net_name],
                    ["Mobile", customer.mobile],
                    ["Address", `${customer.doorno || ""} ${customer.street || ""} ${customer.flat_name || ""}`],
                  ].map(([label, value], i) => (
                    <div key={i} className="col-lg-4 col-6 border-right p-2 py-lg-3">
                      <div className="description-block">
                        <h3 className="description-header">{value}</h3>
                        <span className="description-text text-cyan text-bold">{label}</span>
                      </div>
                    </div>
                  ))}

                  {/* Payable Amount */}
                  <div className="col-lg-4 col-6 border-right p-2 py-lg-3">
                    <div className="description-block">
                      <h3 className="text-bold blink">₹ {payAmount}.00</h3>
                      <span className="description-text text-cyan text-bold">Payable Amount</span>
                    </div>
                  </div>

                  {/* Edit Pay */}
                  <div className="col-lg-4 col-6 border-right p-2 py-lg-3">
                    <div className="description-block">
                      {!isVisible ? (
                        <button className="btn btn-info" onClick={() => setIsVisible(true)}>
                          Edit Pay Amount
                        </button>
                      ) : (
                        <>
                          <input
                            type="text"
                            className="form-control text-center"
                            value={payAmount}
                            onChange={(e) => setPayAmount(Number(e.target.value))}
                          />
                          <div className="mt-2">
                            <button
                              className="btn btn-sm btn-secondary"
                              onClick={() => {
                                const reset = Number(customer.balance_amt) + Number(customer.pend_amt);
                                setPayAmount(reset);
                                toast.warning("Payable Amount Reversed ↻");
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
{/* 🔹 SRCV1 Extra Fields */}
{user === "srcv1" && (
  <>
    {/* Payment Mode */}
    <div className="col-lg-4 col-6 border-right p-2">
      <div className="description-block">
          <span className="description-text text-cyan text-bold">
          Payment Mode
        </span>
        <select
          className="form-control"
          value={paymentMode}
          onChange={(e) => setPaymentMode(e.target.value)}
        >
          <option value="Cash">Cash</option>
          <option value="Cheque">Cheque</option>
          <option value="Online">Online</option>
        </select>
      
      </div>
    </div>

    {/* Cheque Number (only if Cheque selected) */}
    {paymentMode === "Cheque" && (
      <div className="col-lg-4 col-6 border-right p-2">
        <div className="description-block">
           <span className="description-text text-cyan text-bold">
            Cheque Number
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Cheque Number"
            value={chequeNo}
            onChange={(e) => setChequeNo(e.target.value)}
          />
         
        </div>
      </div>
    )}

    {/* Remarks */}
    <div className="col-lg-4 col-6 border-right p-2">
      <div className="description-block">
         <span className="description-text text-cyan text-bold">
          Remarks
        </span>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
       
      </div>
    </div>

    {/* Payment For */}
    <div className="col-lg-4 col-6 border-right p-2">
      <div className="description-block">
         <span className="description-text text-cyan text-bold">
          Payment For
        </span>
        <input
          type="text"
          list="paymentForList"
          className="form-control"
          placeholder="Payment For"
          value={paymentFor}
          onChange={(e) => setPaymentFor(e.target.value)}
        />
        <datalist id="paymentForList">
          <option value="Sairam Communication" />
          <option value="SRCV" />
          <option value="Limras Eronet" />
        </datalist>

       
      </div>
    </div>
  </>
)}
                  {/* Staff */}
                  <div className="col-lg-4 col-6 border-right p-2 d-flex justify-content-center">
                    <div className="description-block w-100">
                       <span className="description-text text-cyan text-bold">Collected Staff</span>
                      <select className="form-control bg-light" onChange={(e) => setSelectedStaff(e.target.value)}>
                        <option value="">Select a staff</option>
                        
                        {staff.map((row, i) => (
                          <option key={i} value={`${row.name}|${row.staffCode}|${row.mobile}`}>
                            {row.name} ({row.staffCode})
                          </option>
                        ))}
                      </select>
                     
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="col-lg-12 border-top p-2 d-flex justify-content-lg-end justify-content-center">
                    <button className="btn-lg btn-success m-2" disabled={payBtn} onClick={handleSave}>
                      Pay ₹ {payAmount}
                    </button>
                    <button className="btn-lg btn-danger m-2" onClick={() => navigate("/allCustomer/all")}>
                      Back
                    </button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Payment);
